export default "__VITE_ASSET__dbfb3303__"